import { jsx as t } from "react/jsx-runtime";
import r from "./index.es817.js";
import f from "classnames";
import p from "lodash/uniqueId";
const v = "loading-bar", b = ({
  testId: c = v,
  mode: s,
  progress: a,
  status: i,
  label: n = "Loading content"
}) => {
  const d = p("progressBar-"), m = i === "error" ? r.error : i === "success" ? r.success : r.loading, u = f(
    r.bar,
    (!s || s !== "progress") && r["loading-mode"],
    m
  ), l = !s || s !== "progress", o = {
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100
  };
  !l && a !== void 0 && (o["aria-valuenow"] = a);
  let e;
  return i === "error" ? e = "Error occurred" : i === "success" ? e = "Successfully completed" : l ? e = "Loading, please wait" : a !== void 0 && (e = `${a}% complete`), e && (o["aria-valuetext"] = e), /* @__PURE__ */ t(
    "div",
    {
      className: r.root,
      id: d,
      "aria-label": n,
      "data-testid": c,
      ...o,
      children: /* @__PURE__ */ t("div", { className: u, style: { width: a ? `${a}%` : "60%" } })
    }
  );
};
export {
  v as LOADING_DEFAULT_TESTID,
  b as LoadingBar
};
//# sourceMappingURL=index.es69.js.map
